import { Component } from '@angular/core';

@Component({
  selector: 'app-user',
  templateUrl: './account-register-success.component.html',
  styleUrls: ['./account-register-success.component.scss'],
})
export class AccountRegisterSuccessComponent {}
